var locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/en_US.js
// module id = 208
// module chunks = 0